<div *ngIf="disableNavigation">
  <span>{{ params.value || "—" }}</span>
</div>

<ng-container *ngIf="!disableNavigation && !!this.params.colDef?.cellRendererParams?.clicked; else routingLink">  
  <a [ngStyle]="inlineStyles" [ngClass]="customClass" [attr.title]="showToolTip ? params.value : null" (click)="onClick()" *ngIf="isVisibility">  
      {{ params.value }}  
  </a>  
</ng-container>  

<ng-template #routingLink>  
  <a [attr.title]="showToolTip ? params.value : null"  
     [queryParams]="queryParams"  
     *ngIf="params.colDef?.cellRendererParams?.rootUrl; else other"  
     [routerLink]="[  
         '/' + params.colDef?.cellRendererParams?.route,  
         params.colDef?.cellRendererParams?.property ? params.data[params.colDef?.cellRendererParams?.property] : params.data.id  
     ]"  
     [ngClass]="customClass">{{ params.value }}</a>  
     
  <ng-template #other>  
      <a [queryParams]="queryParams"  
         [attr.title]="showToolTip ? params.value : null"  
         *ngIf="!params.colDef?.cellRendererParams?.hasParent; else parent"  
         [ngClass]="customClass"  
         [routerLink]="[  
             params.colDef?.cellRendererParams?.route ? '../' + params.colDef?.cellRendererParams?.route : './',  
             params.colDef?.cellRendererParams?.property ? params.data[params.colDef?.cellRendererParams?.property] : params.data.id  
         ]">{{ params.value || "—" }}</a>  
  </ng-template>  

  <ng-template #parent>  
      <a [queryParams]="queryParams"  
         [attr.title]="showToolTip ? params.value : null"  
         [ngClass]="customClass"  
         [routerLink]="[  
             params.colDef?.cellRendererParams?.route,  
             params.data[params.colDef?.cellRendererParams?.property]  
         ]">{{ params.value || "—" }}</a>  
  </ng-template>  
</ng-template>